import { ClassValue } from 'clsx';
import cn from '../../app/utils/cn';
import image from '../assets/emptyState.svg';

interface IEmptyStateProps {
  className?: ClassValue;
  children?: React.ReactNode;
}

export default function EmptyState({ className, children }: IEmptyStateProps) {
  return (
    <div className="text-text-primary flex size-full flex-col items-center justify-center">
      <img
        className={cn('mb-4 w-full md:h-1/3 md:w-1/3', className)}
        src={image}
        alt="Empty state"
      />
      {children}
    </div>
  );
}
